/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilterOperation } from './FilterOperation';
import {
    FilterOperationFromJSON,
    FilterOperationFromJSONTyped,
    FilterOperationToJSON,
} from './FilterOperation';

/**
 * 
 * @export
 * @interface ContactDetailsFilter
 */
export interface ContactDetailsFilter {
    /**
     * 
     * @type {string}
     * @memberof ContactDetailsFilter
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailsFilter
     */
    value: string;
    /**
     * 
     * @type {FilterOperation}
     * @memberof ContactDetailsFilter
     */
    operation: FilterOperation;
}


/**
 * Check if a given object implements the ContactDetailsFilter interface.
 */
export function instanceOfContactDetailsFilter(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "key" in value;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "operation" in value;

    return isInstance;
}

export function ContactDetailsFilterFromJSON(json: any): ContactDetailsFilter {
    return ContactDetailsFilterFromJSONTyped(json, false);
}

export function ContactDetailsFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDetailsFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': json['value'],
        'operation': FilterOperationFromJSON(json['operation']),
    };
}

export function ContactDetailsFilterToJSON(value?: ContactDetailsFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value,
        'operation': FilterOperationToJSON(value.operation),
    };
}

